import React, { useState, useEffect } from "react";
import ModalAddModel from "./ModalAddModel";
import ModalAddType from "./ModalAddType";
import ModalAddWindFarm from "./ModalAddWindFarm";

const API_BASE_URL = `${process.env.REACT_APP_API_URL.replace(/\/$/, '')}/api`;

const ModalAddTurbine = ({ isOpen, onClose, turbine, isEmbedded = false, onOpenModelModal, regions }) => {
  console.log("przekazane dane do edycji:", turbine);
  const [formData, setFormData] = useState({
    turbine_number: "",
    name: "",
    model: "",
    type: "",
    location: "",
    wind_farm: "",
    height: "",
    power: "",
  });

  const [models, setModels] = useState([]); // Lista modeli
  const [selectedModel, setSelectedModel] = useState(null); // Wybrany model (zawiera również typy)
  const [windFarms, setWindFarms] = useState([]); // Lista farm wiatrowych
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  
  const token = localStorage.getItem("access_token");

  const fetchData = async () => {
    setLoading(true);
    try {
      const [modelsResponse, windFarmsResponse] = await Promise.all([
        fetch(`${API_BASE_URL}/models`, {
          method: "GET",
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
          },
        }),
        fetch(`${API_BASE_URL}/windfarms`, {
          method: "GET",
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
          },
        }),
      ]);

      if (!modelsResponse.ok || !windFarmsResponse.ok) {
        throw new Error("Błąd pobierania danych z API");
      }

      const modelsData = await modelsResponse.json();
      const windFarmsData = await windFarmsResponse.json();

      setModels(modelsData || []); // Jeśli brak danych, ustaw pustą tablicę
      setWindFarms(windFarmsData || []); // Jeśli brak danych, ustaw pustą tablicę
      return modelsData;
    } catch (err) {
      setError(err.message);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (turbine && models.length > 0) {
      const matchedModel = models.find((model) => model.id === turbine.modelId) || null;
  
      // Ustaw selectedModel i upewnij się, że types są zainicjalizowane
      setSelectedModel({
        ...matchedModel,
        types: matchedModel?.types || [], // Domyślnie ustaw pustą tablicę
      });
  
      // Ustaw odpowiedni typ w formData
      const matchedType = matchedModel?.types?.find((type) => type.id === turbine.typeId);
      setFormData((prev) => ({
        ...prev,
        type: matchedType ? matchedType.id : "", // Jeśli znajdzie typ, ustaw, w przeciwnym razie zresetuj
      }));
    }
  }, [models, turbine]);
  

  useEffect(() => {
    if (isOpen) {
      fetchData();

      // Jeśli otrzymujemy dane turbiny jako props, ustawiamy je w stanie
      if (turbine) {        

        setFormData({
          turbine_number: turbine.number || "",
          name: turbine.name || "",
          model: turbine.modelId || "",
          type: turbine.typeId || "",
          location: turbine.location || "",
          wind_farm: turbine.windFarmId || "",
          height: turbine.height || "",
          power: turbine.power || "",
        });

        const matchedModel = models.find((model) => model.id === turbine.modelId) || null;
        setSelectedModel({
          ...matchedModel,
          types: matchedModel?.types || [], // Domyślnie ustaw pustą tablicę
        });
        setWindFarms(turbine.windFarmId);
        
      }
    }
  }, [isOpen, turbine]);

  useEffect(() => {
    if (selectedModel && selectedModel.types) {
      const matchedType = selectedModel.types.find((type) => type.id === formData.type);
      if (!matchedType) {
        setFormData((prev) => ({
          ...prev,
          type: "", // Zresetuj typ, jeśli nie ma dopasowania
        }));
      }
    }
  }, [selectedModel]);


  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleModelChange = (e) => {
    const modelId = e.target.value;
    const selected = models.find((model) => model.id.toString() === modelId);
  
    setSelectedModel(selected || null);
    setFormData((prev) => ({
      ...prev,
      model: modelId, // Przechowujemy ID modelu
      type: "", // Resetujemy typ przy zmianie modelu
    }));
  };

  const handleSave = async () => {
    try {
      setLoading(true);

      const dataToSend = {
        ...formData,
        model: parseInt(formData.model, 10),
        type: parseInt(formData.type, 10),
        wind_farm: parseInt(formData.wind_farm, 10),
        height: parseFloat(formData.height), // Jeśli height to liczba zmiennoprzecinkowa
        power: parseFloat(formData.power),   // Jeśli power to liczba zmiennoprzecinkowa
      };

      console.log("Wysyłane dane:", dataToSend);

      const endpoint = turbine
        ? `${API_BASE_URL}/turbines/${turbine.id}/`
        : `${API_BASE_URL}/turbines/`;
      const method = turbine ? "PUT" : "POST";

      const response = await fetch(endpoint, {
        method,
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
        body: JSON.stringify(dataToSend),
      });

      if (!response.ok) {
        const contentType = response.headers.get("content-type");

        // Jeśli odpowiedź jest HTML, wyświetlamy błąd serwera
        if (contentType && contentType.includes("text/html")) {
            const errorText = await response.text();
            console.error("Serwer zwrócił stronę HTML:", errorText);
            throw new Error(`Błąd serwera: ${response.status} - Sprawdź logi backendu`);
        }

        // Pobieramy odpowiedź jako JSON
        const errorData = await response.json();
        console.error("Błąd API:", errorData);

        // Jeśli API zwróciło `detail`, używamy go
        if (errorData.detail) {
            throw new Error(errorData.detail);
        }

        // Jeśli API zwróciło inne błędy (np. `turbine_number`), wyciągamy pierwszy dostępny komunikat
        const firstErrorKey = Object.keys(errorData)[0]; // Pobieramy pierwszy klucz (np. 'turbine_number')
        const firstErrorMessage = errorData[firstErrorKey]; // Pobieramy wartość tego błędu

        // Jeśli jest tablica błędów, wyciągamy pierwszy komunikat, inaczej bierzemy całą wartość
        throw new Error(Array.isArray(firstErrorMessage) ? firstErrorMessage[0] : firstErrorMessage);
    }

      const result = await response.json();
      console.log("Turbina zapisana:", result);

      // Resetuj pola, zamknij modal i odśwież dane
      setFormData({
        turbine_number: "",
        name: "",
        model: "",
        type: "",
        location: "",
        wind_farm: "",
        height: "",
        power: "",
      });
      setSelectedModel(null);
      onClose();
      console.log("Wywołano onClose po edycji.");      
    } catch (err) {
      console.error(err.message);
      alert(err.message || "Wystąpił błąd podczas zapisywania turbiny.");
    } finally {
      setLoading(false);
    }
  };

  const [isAddModelOpen, setIsAddModelOpen] = useState(false);
  const handleOpenAddModel = () => setIsAddModelOpen(true);
  const handleCloseAddModel = () => {
    setIsAddModelOpen(false);
    fetchData(); // Wywołanie fetchData po zamknięciu modala
  };

  const [isAddTypeOpen, setIsAddTypeOpen] = useState(false);

  const handleAddNewType = () => {
    if (!selectedModel) {
      alert("Wybierz model, aby dodać nowy typ!");
      return;
    }
    setIsAddTypeOpen(true);
  };

  const handleCloseAddType = () => {
    setIsAddTypeOpen(false);
    fetchData(); // Odśwież dane po zamknięciu modala
  };

  const handleTypeSaved = async (typeId) => {
    console.log("Przekazane ID typu:", typeId);
  
    // Odśwież dane modeli
    const updatedModels = await fetchData();
  
    // Znajdź wybrany model w zaktualizowanych danych
    const updatedModel = updatedModels.find((model) => model.id === selectedModel?.id);
  
    if (updatedModel) {
      // Zaktualizuj wybrany model
      setSelectedModel(updatedModel);
  
      // Znajdź nowo dodany typ w zaktualizowanym modelu
      const savedType = updatedModel.types.find((type) => type.id === typeId);
  
      if (savedType) {
        // Ustaw typ jako wybrany w formularzu
        setFormData((prev) => ({
          ...prev,
          type: typeId, // Ustaw typ jako wybrany w polu select
        }));
      }
    }
  
    setIsAddTypeOpen(false); // Zamknij modal dodawania typu
  };

  const handleClose = () => {
    setFormData({
      turbine_number: "",
      name: "",
      model: "",
      type: "",
      location: "",
      wind_farm: "",
      height: "",
      power: "",
    });
    setSelectedModel(null);
    onClose(); // Wywołanie funkcji zamykającej przekazanej przez rodzica
  };

  const handleModelSaved = async (modelId) => {
    console.log("Przekazane ID:", modelId);
  
    // Odśwież dane modeli i zapisz zaktualizowaną listę
    const updatedModels = await fetchData();
  
    // Znajdź model na podstawie przekazanego ID w zaktualizowanej liście
    const savedModel = updatedModels.find((model) => model.id === modelId);
    console.log("Wybrany model:", savedModel);
  
    if (savedModel) {
      // Ustaw model jako wybrany w formularzu i zaznacz go jako selectedModel
      setFormData((prev) => ({
        ...prev,
        model: modelId, // Ustaw model jako wybrany w polu select
      }));
      setSelectedModel(savedModel); // Ustaw model jako wybrany obiekt
    }
  
    setIsAddModelOpen(false); // Zamknij modal
  };

  const [isAddWindFarmOpen, setIsAddWindFarmOpen] = useState(false);

  const handleOpenAddWindFarm = () => setIsAddWindFarmOpen(true);
  const handleCloseAddWindFarm = async () => {
    setIsAddWindFarmOpen(false);
    await fetchData(); // Odśwież listę farm wiatrowych
  };

  const handleWindFarmSaved = async (windFarmId) => {
    console.log("Saved wind farm ID:", windFarmId);
  
    // Odśwież listę farm wiatrowych
    await fetchData();
  
    // Ustaw nową farmę jako wybraną w formularzu
    setFormData((prev) => ({
      ...prev,
      wind_farm: windFarmId, // Ustaw nową farmę jako wybraną
    }));
  
    setIsAddWindFarmOpen(false); // Zamknij modal
  };

  if (!isOpen) return null;

  // Form content to be reused in both embedded and modal views
  const formContent = (
    <>
      {loading ? (
        <div className="text-graphite-700 text-center">Loading...</div>
      ) : error ? (
        <div className="text-red-500 text-center">{error}</div>
      ) : (
        <form className={`${isEmbedded ? 'grid grid-cols-1' : 'grid grid-cols-2'}`}>
          {/* Pole numer turbiny */}
          <div>
            <label className="block text-sm font-medium text-graphite-700">
              Turbine Number
            </label>
            <input
              type="text"
              name="turbine_number"
              value={formData.turbine_number}
              onChange={handleInputChange}
              className="w-full border rounded px-3 py-2 mb-4"
              placeholder="Turbine Number"
            />
          </div>

          {/* Pole nazwa turbiny */}
          <div>
            <label className="block text-sm font-medium text-graphite-700">
              Turbine Name
            </label>
            <input
              type="text"
              name="name"
              value={formData.name}
              onChange={handleInputChange}
              className="w-full border rounded px-3 py-2 mb-4"
              placeholder="Turbine Name"
            />
          </div>

          {/* Pole model */}
          <div>
            <label className="block text-sm font-medium text-graphite-700">
              Model
            </label>
            <div className="flex space-x-2 mb-4">
              <select
                name="model"
                value={formData.model}
                onChange={handleModelChange}
                className="w-full border rounded text-graphite-700 px-3 py-2 focus:outline-none focus:ring-2 focus:ring-brand-500"
              >
                <option value="">-- Choose model --</option>
                {models.map((model) => (
                  <option key={model.id} value={model.id}>
                    {model.name}
                  </option>
                ))}
              </select>
              <button
                type="button"
                onClick={handleOpenAddModel}
                className="px-4 py-2 bg-brand-500 text-white rounded-md hover:bg-brand-600 transition"
              >
                +
              </button>
            </div>
          </div>

          {/* Pole typ */}
          <div>
            <label className="block text-sm font-medium text-graphite-700">
              Type
            </label>
            <div className="flex space-x-2 mb-4">
              <select
                name="type"
                value={formData.type}
                onChange={handleInputChange}
                disabled={!selectedModel || selectedModel.types.length === 0}
                className="w-full border rounded text-graphite-700 px-3 py-2 focus:outline-none focus:ring-2 focus:ring-brand-500"
              >
                {selectedModel ? (
                  <>
                    <option value="">-- Choose type --</option>
                    {selectedModel && selectedModel.types?.map((type) => (
                      <option key={type.id} value={type.id}>
                        {type.name}
                      </option>
                    ))}
                  </>
                ) : (
                  <option value="">Chose model</option>
                )}
              </select>
              {selectedModel && (
                <button
                  type="button"
                  onClick={handleAddNewType}
                  className="px-4 py-2 bg-brand-500 text-white rounded hover:bg-brand-600 transition"
                >
                  +
                </button>
              )}
            </div>
          </div>            

          {/* Pole farma wiatrowa */}
          <div>
            <label className="block text-sm font-medium text-graphite-700">
              Wind Farm
            </label>
            <div className="flex mb-4 space-x-2">
              <select
                name="wind_farm"
                value={formData.wind_farm}
                onChange={handleInputChange}
                className="w-full border rounded px-3 py-2 text-graphite-700"
              >
                <option value="">-- Choose windfarm --</option>
                {windFarms.map((farm) => (
                  <option key={farm.id} value={farm.id}>
                    {farm.name}
                  </option>
                ))}
              </select>
              <button
                type="button"
                onClick={handleOpenAddWindFarm}
                className="px-4 py-2 bg-brand-500 text-white rounded hover:bg-brand-600 transition"
              >
                +
              </button>
            </div>
          </div>

          {/* Pole lokalizacja */}
          <div>
            <label className="block text-sm font-medium text-graphite-700">
              Location
            </label>
            <input
              type="text"
              name="location"
              value={formData.location}
              onChange={handleInputChange}
              className="w-full border rounded px-3 py-2 mb-4"
              placeholder="Location"
            />
          </div>

          {/* Pole wysokość */}
          <div>
            <label className="block text-sm font-medium text-graphite-700">
              Height (m)
            </label>
            <input
              type="text"
              name="height"
              value={formData.height}
              onChange={handleInputChange}
              className="w-full border rounded px-3 py-2 mb-4"
              placeholder="Height (m)"
            />
          </div>

          {/* Pole moc */}
          <div>
            <label className="block text-sm font-medium text-graphite-700">
              Power (kW)
            </label>
            <input
              type="text"
              name="power"
              value={formData.power}
              onChange={handleInputChange}
              className="w-full border rounded px-3 py-2 mb-6"
              placeholder="Power (kW)"
            />
          </div>
        </form>
      )}

      <div className="flex justify-end space-x-2">
        <button
          onClick={handleClose}
          className="px-4 py-2  border border-steel-300 text-graphite-700 font-medium rounded-full hover:bg-steel-100 flex items-center text-sm whitespace-nowrap"
        >
          Cancel
        </button>
        <button
          onClick={handleSave}
          className="px-4 py-2  border border-brand-500 bg-brand-500 font-medium text-white rounded-full hover:bg-brand-600 flex items-center text-sm whitespace-nowrap"
        >
          Save
        </button>
      </div>

      {/* Nested modals for adding related entities */}
      <ModalAddModel
        isOpen={isAddModelOpen}
        onClose={handleCloseAddModel}
        onSave={handleModelSaved}
        isEmbedded={false}
      />
      <ModalAddType
        isOpen={isAddTypeOpen}
        onClose={handleCloseAddType}
        modelId={selectedModel?.id}
        onSave={handleTypeSaved}
        isEmbedded={false}
      />
      <ModalAddWindFarm
        isOpen={isAddWindFarmOpen}
        onClose={handleCloseAddWindFarm}
        onSave={handleWindFarmSaved}
        isEmbedded={false}
        regions={regions}
      />
    </>
  );

  // When embedded in the toggle menu
  if (isEmbedded) {
    return (
      <div>
        <h3 className="text-lg font-semibold mb-4">Add New Turbine</h3>
        {formContent}
      </div>
    );
  }

  // When used as a standalone modal
  return (
    <div className="fixed inset-0 bg-graphite-950/50 flex justify-center items-center z-50"
      style={{ zIndex: 70 }}
    >
      <div className="bg-white w-2/3 h-3/4 rounded-lg shadow-lg p-6 relative overflow-auto">
        <button
          onClick={onClose}
          className="absolute top-4 right-4 text-graphite-500 hover:text-graphite-900"
        >
          &#10005;
        </button>
        <h2 className="text-2xl font-semibold text-graphite-900 mb-6">
          {turbine ? "Edit Turbine" : "Add New Turbine"}
        </h2>

        {formContent}
      </div>
    </div>
  );
};

export default ModalAddTurbine;